import React from 'react';

import { Container } from './RoFormGroup.styles';

const RoFormGroup = props => <Container className={props.className}>{props.children}</Container>;

export default RoFormGroup;
